const NoAccess = () => {
  return (
    <div>You don't have access to this page. Kindly contact your admin</div>
  );
};

export default NoAccess;
